import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

// Property Leads
export const Get_Property_Leads = createAsyncThunk(
  "leads/get-property-leads",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Leads.Get_Property_Leads}?name=${
          filter?.name || ""
        }&contact_no=${filter?.contact_no || ""}&page=${
          filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Expert Leads
export const Get_Expert_Leads = createAsyncThunk(
  "leads/get-expert-leads",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Leads.Get_Expert_Leads}?name=${
          filter?.name || ""
        }&contact_no=${filter?.contact_no || ""}&page=${
          filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "lead",
  initialState: {
    propertyLeads: [],
    expertLeads: [],

    propertyPagination: {
      current_page: IDS.PAGE,
      total_pages: IDS.TOTALPAGES,
      per_page: IDS.PERPAGE,
      total: IDS.TOTAL,
    },

    expertPagination: {
      current_page: IDS.PAGE,
      total_pages: IDS.TOTALPAGES,
      per_page: IDS.PERPAGE,
      total: IDS.TOTAL,
    },

    propertyStatus: IDS.SLICESTATUS.Idle,
    expertStatus: IDS.SLICESTATUS.Idle,

    propertyError: null,
    expertError: null,
  },

  reducers: {},

  extraReducers: (builder) => {
    // ================= Property Leads =================
    builder
      .addCase(Get_Property_Leads.pending, (state) => {
        state.propertyStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(Get_Property_Leads.fulfilled, (state, action) => {
        state.propertyStatus = IDS.SLICESTATUS.Succeeded;

        state.propertyLeads = action.payload?.data?.data || [];

        state.propertyPagination.current_page =
          action.payload?.data?.current_page || IDS.PAGE;
        state.propertyPagination.total_pages =
          action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.propertyPagination.per_page =
          action.payload?.data?.per_page || IDS.PERPAGE;
        state.propertyPagination.total =
          action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(Get_Property_Leads.rejected, (state, action) => {
        state.propertyStatus = IDS.SLICESTATUS.Failed;
        state.propertyError = action.payload;
      });

    // ================= Expert Leads =================
    builder
      .addCase(Get_Expert_Leads.pending, (state) => {
        state.expertStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(Get_Expert_Leads.fulfilled, (state, action) => {
        state.expertStatus = IDS.SLICESTATUS.Succeeded;

        state.expertLeads = action.payload?.data?.data || [];

        state.expertPagination.current_page =
          action.payload?.data?.current_page || IDS.PAGE;
        state.expertPagination.total_pages =
          action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.expertPagination.per_page =
          action.payload?.data?.per_page || IDS.PERPAGE;
        state.expertPagination.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(Get_Expert_Leads.rejected, (state, action) => {
        state.expertStatus = IDS.SLICESTATUS.Failed;
        state.expertError = action.payload;
      });
  },
});

export default Slice.reducer;
